<!-- eslint-disable -->
<template>
  <v-container class="login-page" fluid>
    <!-- Background -->
    <div class="login-bg" aria-hidden="true">
      <div class="bg-gradient"></div>
      <div class="bg-pattern"></div>

      <!-- watermark logo (dari logoData) -->
      <div class="bg-watermark" v-html="logoMethod"></div>
    </div>

    <v-row align="center" justify="center" class="login-row">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <v-card class="login-card" elevation="14">
          <!-- Header -->
          <div class="login-header">
            <div class="logo-wrap">
              <svg
                id="logo"
                viewBox="0 0 483 483"
                xml:space="preserve"
                width="64"
                height="64"
                v-html="logoMethod"
              ></svg>
            </div>

            <div class="title-wrap">
              <div class="app-title">siPeg BPDP</div>
              <div class="app-subtitle">Attendance Kepegawaian</div>
            </div>
          </div>

          <v-divider />

          <v-card-text class="px-6 pt-6">
            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="handleLogin">
              <v-text-field
                v-model="email"
                :rules="[rules.required]"
                label="E-mail"
                prepend-inner-icon="mdi-email-outline"
                outlined
                dense
                autocomplete="username"
                class="field"
              />

              <v-text-field
                v-model="password"
                label="Password"
                :type="showPass ? 'text' : 'password'"
                :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPass = !showPass"
                :rules="[rules.required, rules.min]"
                prepend-inner-icon="mdi-lock-outline"
                outlined
                dense
                autocomplete="current-password"
                class="field"
              />

              <v-btn
                type="submit"
                block
                large
                class="btn-login mt-2"
                :disabled="!valid || isLoading"
                :loading="isLoading"
              >
                <v-icon left>mdi-login</v-icon>
                Login
              </v-btn>

              <div class="helper mt-4">
                <v-icon small class="mr-1 helper-ico">mdi-shield-check-outline</v-icon>
                <span>Gunakan akun resmi BPDP. Aktivitas tercatat untuk keamanan.</span>
              </div>
            </v-form>
          </v-card-text>

          <v-divider />

          <v-card-actions class="px-6 py-4">
            <div class="footer-left">
              <v-icon small class="mr-1 footer-ico">mdi-office-building</v-icon>
              <span class="caption">BPDP</span>
              <span class="dot">•</span>
              <span class="caption">Helpdesk TI</span>
            </div>

            <v-spacer />

            <v-chip small outlined class="chip-env">
              <v-icon left small>mdi-server</v-icon>
              PROD
            </v-chip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="toast.show" :timeout="toast.timeout">
      {{ toast.text }}
      <v-btn :color="toast.color" text @click="toast.show = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="isLoading" fullscreen>
      <v-container fluid fill-height style="background-color: rgba(0, 0, 0, 0.75);">
        <v-layout justify-center align-center>
          <v-card width="70vW" class="pa-md-2 mx-lg-auto" outlined>
            <v-list-item three-line centered>
              <v-list-item-content>
                <div class="overline mb-4">Processing</div>
                <v-list-item-title class="headline mb-1">Please Wait....</v-list-item-title>
                <v-list-item-subtitle>
                  <v-progress-linear indeterminate color="amber darken-2"></v-progress-linear>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-container>
</template>

<script>
import Vivus from "vivus";
import logoData from "./logoData";
import { loginByUsername } from "@/api/login";
import { getSettingParamAbsenVersioning } from "@/api/settingparam";

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => (v || "").length >= 8 || "Min 8 characters",
      },
      valid: false,
      showPass: false,
      vivus: null,
      toast: { show: false, color: "green", text: "", timeout: 2000 },
      isLoading: false,
    };
  },
  computed: {
    logoMethod() {
      return logoData["Digitalizer"];
    },
  },
  mounted() {
    this.startAnimation();
    this.setSettingVersioning();
  },
  methods: {
    startAnimation() {
      // animasi garis logo (kalau svg compatible)
      this.vivus = new Vivus(
        "logo",
        { duration: 240, forceRender: false },
        (element) => {
          const children = element?.el?.children?.[0]?.children || [];
          for (const item of children) item.style.fill = "white";
        }
      );
    },

    async handleLogin() {
      if (this.isLoading) return;

      const ok = this.$refs.form?.validate?.();
      if (ok === false) return;

      this.isLoading = true;
      try {
        const response = await loginByUsername(this.email, this.password);

        const user = response?.data?.user;
        const jwt = response?.data?.jwt;
        if (!user || !jwt) throw new Error("Invalid login response");

        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("jwt", jwt);

        // pastikan mutation SET_USER ada di src/store.js
        this.$store.commit("SET_USER", user);

        const nextUrl = this.$route?.params?.nextUrl;
        this.$router.push(nextUrl || "/");
      } catch (err) {
        console.log(err);
        this.toast = {
          show: true,
          color: "red",
          text: "Username or Password was incorrect!",
          timeout: 2000,
        };
      } finally {
        this.isLoading = false;
      }
    },

    async setSettingVersioning() {
      try {
        const response = await getSettingParamAbsenVersioning();
        const array = response?.data || [];
        const found = array.find((x) => x?.Deskripsi === "absenVersioning");
        if (found?.value != null) localStorage.setItem("currVersion", found.value);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
/* ===== BPDP Color Tokens =====
Green Grass   : #1F5630
Sunny Yellow  : #F5832B
Gray Rain     : #B7B9BB
Lava Black    : #352F36
Pure White    : #FFFFFF
Pure Black    : #000000
*/

/* Page */
.login-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  padding: 0;
}

/* Background layers */
.login-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.bg-gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(1000px 650px at 15% 20%, rgba(245, 131, 43, 0.18), transparent 60%),
    radial-gradient(900px 650px at 85% 10%, rgba(31, 86, 48, 0.30), transparent 60%),
    linear-gradient(135deg, #1F5630 0%, #352F36 100%);
}

/* icon pack as subtle pattern */
.bg-pattern {
  position: absolute;
  inset: 0;
  background-image: url("~@/assets/bpdp-icon-pack.svg");
  background-repeat: repeat;
  background-size: 190px;
  opacity: 0.08;
  filter: grayscale(100%);
  mix-blend-mode: overlay;
}

/* watermark logo from logoData */
.bg-watermark {
  position: absolute;
  right: -120px;
  bottom: -140px;
  width: 520px;
  height: 520px;
  opacity: 0.07;
  transform: rotate(-10deg);
  pointer-events: none;
}

/* ensure watermark svg scales */
.bg-watermark :deep(svg) {
  width: 100%;
  height: 100%;
}

/* Centering */
.login-row {
  min-height: 100vh;
  position: relative;
  z-index: 1;
  padding: 22px 12px;
}

/* Card */
.login-card {
  border-radius: 20px;
  overflow: hidden;
  background: #FFFFFF;
  box-shadow: 0 24px 55px rgba(0, 0, 0, 0.35);
}

/* Header */
.login-header {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 22px 22px 18px;
  color: #FFFFFF;
  background: linear-gradient(90deg, rgba(31, 86, 48, 0.98), rgba(245, 131, 43, 0.92));
}

.logo-wrap {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: rgba(0, 0, 0, 0.18);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.title-wrap {
  line-height: 1.1;
}

.app-title {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.app-subtitle {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 4px;
}

/* Fields */
.field :deep(.v-input__slot) {
  border-radius: 14px !important;
}

/* Button */
.btn-login {
  border-radius: 14px;
  background: #F5832B !important;
  color: #FFFFFF !important;
  box-shadow: 0 10px 22px rgba(245, 131, 43, 0.35);
}

.btn-login :deep(.v-btn__loading) {
  color: #FFFFFF;
}

/* Helper */
.helper {
  display: flex;
  align-items: flex-start;
  font-size: 12px;
  color: #352F36;
  opacity: 0.75;
}

.helper-ico {
  color: #1F5630;
  margin-top: 2px;
}

/* Footer */
.footer-left {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #352F36;
  opacity: 0.8;
}

.footer-ico {
  color: #1F5630;
}

.dot {
  opacity: 0.6;
}

.chip-env {
  border-color: rgba(31, 86, 48, 0.35) !important;
  color: #1F5630 !important;
}
</style>
<!-- eslint-enable -->